module.exports = __webpack_public_path__ + "img/appIcon-menu--Settings.8b591943.svg";